import { NULL_ADDRESS } from './contracts';

export const isValidAddress = (address?: string | null) =>
  address && address !== NULL_ADDRESS;
